var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationPaused(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000008299"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 557",
    cx: 12,
    cy: 12.5,
    r: 12,
    fill: "#F5EDCA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "stop"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3711_39343",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 4,
    y: 4.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3711_39343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "stop_2",
    d: "M7 17.5V7.5H17V17.5H7Z",
    fill: "#FFCC00"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationPaused);
export default __webpack_public_path__ + "static/media/notification-paused.6e72521fe882d3cacfb972a20886dda0.svg";
export { ForwardRef as ReactComponent };